import { render, staticRenderFns } from "./Register.pug?vue&type=template&id=2e4c208a&scoped=true&lang=pug&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"
import style0 from "./Register.scss?vue&type=style&index=0&id=2e4c208a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4c208a",
  null
  
)

export default component.exports